<template>
  <div>
    <div class="w-toast flex-column">
      <img :src="toastData.imgUrl" alt="">
      <p>{{ toastData.txt }}</p>
    </div>
    <div class="toast-mask"></div>
  </div>
</template>

<script>
	export default {
		name: 'w-toast',
		props: {
			toastData: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .w-toast, .toast-mask {
    position: fixed;
    left: 50%;
    top: 40%;
    transform: translateX(-50%) translateY(-50%);
    z-index: 19;
    width: 112px;
    height: 112px;
  }
  .w-toast {
    color: $color-light;
    align-items: center;
    /*justify-content: space-between;*/
    padding: 16px 0;
    img {
      width: 44px;
      margin-left: 10px;
      margin-bottom: 24px;
    }
  }
  .toast-mask {
    border-radius: 4px;
    background-color: rgba($color: #000, $alpha: 0.8);
    z-index: 17;
  }
</style>
